import { render, staticRenderFns } from "./TeamDeckModal.vue?vue&type=template&id=17271a00&scoped=true"
import script from "./TeamDeckModal.vue?vue&type=script&lang=js"
export * from "./TeamDeckModal.vue?vue&type=script&lang=js"
import style0 from "./TeamDeckModal.vue?vue&type=style&index=0&id=17271a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17271a00",
  null
  
)

export default component.exports